/** @deprecated */
export const layouts = {
  tabletLandscapeWithMin: '1025px',
  tabletLandscapeWithMax: '1024px',
}
